import React from "react"
import { Skeleton } from "@mui/material"

import { AppDataTable } from "@components"
import AlertsTableCustomToolbar from "Pages/ReportsAlerts/Alerts/Conditions/@components/Table/Toolbar"


export default function AlertsBaseTable(
	{
		title,
		data,
		columns,
		isLoading,
		filterConditions,
		legend = [],
		isNoAvailability = false
	}) {
	return <>
		{isLoading && <Skeleton variant="rectangular" height={500}/>}
		{!isLoading && <AppDataTable
			toolbarProps={{ actions: false }}
			title={title}
			data={Array.isArray(data) ? data : []}
			columns={columns}
			options={{
				exportExcel: false,
				search: true,
				viewColumns: true,
				customToolbar: () => <AlertsTableCustomToolbar
					legendElements={legend}
					filterConditions={filterConditions}
					isNoAvailability={isNoAvailability}
				/>,
			}}
		/>}
	</>
}


